const config = {
 // BASE_URL: "http://127.0.0.1:5000"
  BASE_URL: "https://sbc.revampaioffice.com/api",
  DOWNLOAD_URL: "https://sbc.revampaioffice.com/appdownload/download.html"
};

export default config;
